var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("жүктелнуде . . . ")])
}
var staticRenderFns = []

export { render, staticRenderFns }